import MuiTheme from "./css/mui-theme";
import Discover from "./views/discover";


function App(props) {
  return (
    <MuiTheme>
      <Discover />
    </MuiTheme>
  )
}

export default App;
